import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Paper, Button, Divider,
  Table, TableHead, TableRow, TableCell, TableBody, TableContainer,
  Select, MenuItem, FormControl, InputLabel
} from '@mui/material';
import { Check } from '@mui/icons-material';
import { collection, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { db } from '../../firebase';
import AddBankAccountModal from '../components/AddBankAccountModal';

export default function Banking() {
  const [accounts, setAccounts] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [statusFilter, setStatusFilter] = useState('Active');
  const [modalOpen, setModalOpen] = useState(false);

  const navigate = useNavigate();

  const fetchAccounts = async () => {
    const snapshot = await getDocs(collection(db, 'bankAccounts'));
    const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setAccounts(data);
    setFiltered(
      statusFilter === 'All'
        ? data
        : data.filter(acc => acc.status === statusFilter)
    );
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  const applyFilter = () => {
    setFiltered(
      statusFilter === 'All'
        ? accounts
        : accounts.filter(acc => acc.status === statusFilter)
    );
  };

  const checkIcon = <Check sx={{ color: 'green' }} fontSize="small" />;

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>Banking</Typography>
      <Divider sx={{ my: 2 }} />

      {/* Filter Row */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <FormControl size="small">
          <InputLabel>Status</InputLabel>
          <Select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            label="Status"
            sx={{ width: 140 }}
          >
            <MenuItem value="All">All</MenuItem>
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Inactive">Inactive</MenuItem>
          </Select>
        </FormControl>
        <Button variant="outlined" onClick={applyFilter}>Apply Filter</Button>
      </Box>

      {/* Action Buttons */}
      <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
        <Button variant="contained" onClick={() => setModalOpen(true)}>+ Add Bank Account</Button>
        <Button variant="outlined">Print Checks</Button>
        <Button variant="outlined">Manage Convenience Fees</Button>
      </Box>

      {/* Modal */}
      <AddBankAccountModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSubmitSuccess={fetchAccounts}
      />

      {/* Bank Table */}
      <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><strong>Name</strong></TableCell>
              <TableCell><strong>Account Number</strong></TableCell>
              <TableCell><strong>Epay Enabled</strong></TableCell>
              <TableCell><strong>Retail Cash Enabled</strong></TableCell>
              <TableCell><strong>Last Reconciliation Date</strong></TableCell>
              <TableCell><strong>Undeposited Funds</strong></TableCell>
              <TableCell><strong>Balance</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filtered.map((acc) => (
              <TableRow
                key={acc.id}
                hover
                sx={{ cursor: 'pointer' }}
                onClick={() => navigate(`/pm/banking/${acc.id}`, { state: acc })}
              >
                <TableCell sx={{ color: '#01457E', fontWeight: 500 }}>
                  {acc.name}
                </TableCell>
                <TableCell>****{acc.last4}</TableCell>
                <TableCell>{(acc.ePayEnabled || acc.epay) && checkIcon}</TableCell>
<TableCell>{(acc.retailCashEnabled || acc.creditCard) && checkIcon}</TableCell>
                <TableCell>{acc.lastReconciliationDate || '—'}</TableCell>
                <TableCell>${acc.undepositedFunds?.toLocaleString() || '0'}</TableCell>
                <TableCell><strong>${acc.balance?.toLocaleString()}</strong></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}